<template>
  <div>
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1>
          Génération de courrier
          <small></small>
        </h1>
        <ol class="breadcrumb">
          <li>
            <router-link :to="{ name: 'Dashboard'}">
              <i class="fa fa-dashboard"></i>
              Accueil
            </router-link>
          </li>
          <li><a href="#">Outils</a></li>
          <li class="active">Génération courrier</li>
        </ol>
      </section>

      <section class="content">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
            <div class="box box-primary">
              <div class="overlay"
                   v-if="generatingPDF">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <div class="box-header with-border">
                <h3 class="box-title">Courrier</h3>
              </div><!-- /.box-header -->
              <div class="box-body">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="form-group">
                      <label for="objetCourrier">Objet du courrier</label>
                      <input type="email" class="form-control" id="objetCourrier"
                             placeholder="Ex: Attestation d'inscriptions" v-model="objet">
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 15px;">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="form-group">
                      <label for="texteCourrier">Texte du courrier</label>
                      <quillEditor ref="courrierTexte"
                                   v-model="content"
                                   :options="editorOption">
                      </quillEditor>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box-footer">
                <p class="text-light-blue pull-left"
                   v-if="(choixPregenerer=='AttestationAffiliationMembresDuClub' && this.getClubSelected)"
                >
                  <i class="fa fa-warning"></i>
                  Le tableau des membres et les colonnes choisies ne seront visibles que dans le PDF exporté</p>
                <button
                  @click="exportToPDF()"
                  :disabled="generatingPDF"
                  type="button" class="btn btn-primary pull-right" style="margin-right: 5px;">
                  <i class="fa fa-download"></i> Générer PDF
                </button>

              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
            <div class="box box-primary">
              <div class="overlay"
                   v-if="generatingPDF">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <div class="box-header with-border">
                <h3 class="box-title">Options</h3>
              </div><!-- /.box-header -->
              <div class="box-body">
                <div class="form-group">
                  <label>Date du courrier:</label>
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <input type="text" name="date" v-model="date"
                           class="form-control pull-right datepicker" id="datepicker1">
                  </div>
                </div>
                <div class="form-group">
                  <label>Destinataire</label>
                  <textarea class="form-control" v-model="adresseDestinataire" rows="3"
                            placeholder="Destinataire..."></textarea>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
            <div class="box box-primary">
              <div class="overlay"
                   v-if="generatingPDF || generatingTemplate">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <div class="box-header with-border">
                <h3 class="box-title">Générateur automatique</h3>
              </div>
              <div class="box-body">
                <div class="form-group">
                  <label for="">Templates</label>
                  <select v-model="choixPregenerer" class="generator form-control">
                    <option :value="null"></option>
                    <option value="AttestationAffiliationMembre">
                      Attestation d'inscription du membre à la fédération
                    </option>
                    <option value="AttestationAffiliationClub">
                      Attestation d'inscription du club à la fédération
                    </option>
                    <option value="AttestationAffiliationMembresDuClub">
                      Attestation avec listing des membres d'un club à la fédération à une date précise
                    </option>
                    <option value="AttestationAffiliationMembresDuClubActifParAnnee">
                      Attestation avec listing des membres d'un club à la fédération actif un jour durant l'année
                    </option>
                    <option value="AttestationAffiliationMembresDuClubPayeDurantAnnee">
                      Attestation avec listing des membres d'un club à la fédération ayant payé leur licence durant l'année
                    </option>
                  </select>
                </div>

                <div class="form-group"
                     v-if="choixPregenerer=='AttestationAffiliationMembre'"
                >
                  <label for="">Sélection du membre</label>

                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-if="getUserSelected">
                    <div class="selection-label">
                                    <span class="selection-label_remove" role="presentation"
                                          @click="removeUserSelected()">×</span>
                      {{ getUserSelected.fullName }}
                    </div>
                  </div>

                  <searchmember ref="searchmember"
                                :limit="5"
                                :min-chars="3"
                  >
                  </searchmember>
                </div>

                <div class="form-group"
                     v-if="choixPregenerer=='AttestationAffiliationClub' ||  choixPregenerer=='AttestationAffiliationMembresDuClub'
                                      || choixPregenerer=='AttestationAffiliationMembresDuClubActifParAnnee' || choixPregenerer=='AttestationAffiliationMembresDuClubPayeDurantAnnee'"
                >
                  <small class="text-danger" v-if="choixPregenerer=='AttestationAffiliationClub'">Aucun listing de membres ne sera ajouté à ce courrier</small>
                  <small class="text-danger" v-if="choixPregenerer=='AttestationAffiliationMembresDuClub'">Le nombre de membre affiché sera le nombre de membres actifs à la date de la demande</small>
                  <small class="text-danger" v-if="choixPregenerer=='AttestationAffiliationMembresDuClubActifParAnnee'">Le nombre de membre calculé sera le nombre de membres qui ont été actif un jour dans l'année</small>
                  <small class="text-danger" v-if="choixPregenerer=='AttestationAffiliationMembresDuClubPayeDurantAnnee'">Le nombre de membre calculé sera le nombre de membres qui ont payé une licence durant l'année</small>
                  <br>
                  <br>
                  <label for="">Sélection du club</label>

                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-if="getClubSelected">
                    <div class="selection-label">
                                    <span class="selection-label_remove" role="presentation"
                                          @click="removeClubSelected()">×</span>
                      {{ getClubSelected.club }}
                    </div>
                  </div>

                  <searchclub ref="searchclub"
                              :limit="5"
                              :min-chars="2"
                  >
                  </searchclub>
                </div>

                <div class="form-group"
                     style="margin-top: 50px;"
                     v-if="(choixPregenerer=='AttestationAffiliationMembre' && this.getUserSelected && this.allLicences!=null)"
                >
                  <label v-if="this.allLicences==null" class="danger" for="">Aucune licence valable pour ce membre</label>
                  <label for="">Sélection de la licence</label>
                  <select v-model="choixLicence" class="generator form-control">
                    <option :value="null"></option>
                    <option v-for="licence in allLicences" :value="licence.id">
                      Licence du {{ licence.date_debut }} au {{ licence.date_fin }}
                    </option>
                  </select>
                </div>

                <div class="form-group"
                     style="margin-top: 50px;"
                     v-if="(choixPregenerer=='AttestationAffiliationClub' && this.getClubSelected && this.allLicencesClub!=null)"
                >
                  <label v-if="this.allLicencesClub==null" class="danger" for="">Aucune licence valable pour ce club</label>
                  <label for="">Sélection de la licence</label>
                  <select v-model="choixLicenceClub" class="generator form-control">
                    <option :value="null"></option>
                    <option v-for="licenceClub in allLicencesClub" :value="licenceClub.id">
                      Licence de {{ licenceClub.annee }}
                    </option>
                  </select>
                </div>

                <div class="form-group"
                     v-if="(choixPregenerer=='AttestationAffiliationMembresDuClub' && this.getClubSelected)"
                >
                  <label>Date de la demande
                    <i class="fa fa-info-circle"
                       data-toggle="tooltip"
                       data-placement="top"
                       title="Permet de calculer le nombre exact de membres affiliés au club à la date indiquée">
                    </i>:
                  </label>
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <input type="text" name="date" v-model="dateDemande"
                           class="form-control pull-right datepicker" id="datepicker2">
                  </div>
                </div>

                <div class="form-group"
                     v-if="((choixPregenerer=='AttestationAffiliationMembresDuClubPayeDurantAnnee' || choixPregenerer=='AttestationAffiliationMembresDuClubActifParAnnee') && this.getClubSelected)"
                >
                  <label>Date de la demande
                    <i class="fa fa-info-circle"
                       data-toggle="tooltip"
                       data-placement="top"
                       title="Permet de calculer le nombre exact de membres affiliés au club à l'année indiquée">
                    </i>:
                  </label>
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <input type="text" name="date" v-model="anneeDemande"
                           class="form-control pull-right" id="datepicker2">
                  </div>
                </div>

                <div class="form-group"
                     v-if="((choixPregenerer=='AttestationAffiliationMembresDuClub' || choixPregenerer=='AttestationAffiliationMembresDuClubPayeDurantAnnee' || choixPregenerer=='AttestationAffiliationMembresDuClubActifParAnnee')  && this.getClubSelected)"
                >
                  <label>Choisir les colonnes
                    <i class="fa fa-info-circle" data-toggle="tooltip"
                       data-placement="top" title="Permet d'ajouter une colonne au listing">
                    </i>:
                  </label>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="columnsSelected" value="numlicenceABFT">
                      Numéro de licence ABFT
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="columnsSelected" value="genre">
                      Genre
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="columnsSelected" value="nom"> Nom du membre
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="columnsSelected" value="prenom"> Prenom du membre
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="columnsSelected" value="adresse"> Adresse du membre
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="columnsSelected" value="cp"> Code postal du membre
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="columnsSelected" value="ville"> Ville du membre
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="columnsSelected" value="date_naissance">
                      Date de naissance du membre
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="columnsSelected" value="tel">
                      Téléphone du membre
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="columnsSelected" value="gsm">
                      GSM du membre
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="columnsSelected" value="mail">
                      Mail du membre
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="columnsSelected" value="date_entree">
                      Date d'entrée à l'ABFT du membre
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="columnsSelected" value="age">
                      <span v-if="choixPregenerer=='AttestationAffiliationMembresDuClub'">Age du membre à la date de la demande </span>
                      <span v-if="choixPregenerer=='AttestationAffiliationMembresDuClubActifParAnnee'">Age du membre au 31/12/{{anneeDemande}}</span>
                      <span v-if="choixPregenerer=='AttestationAffiliationMembresDuClubPayeDurantAnnee'">Age du membre au 31/12/{{anneeDemande}} </span>

                    </label>
                  </div>
                </div>

                <div class="form-group">
                  <button
                    type="button"
                    v-if="choixPregenerer && (getUserSelected || getClubSelected)"
                    :disabled="disabledButton()"
                    @click="generateTemplate()"
                    style="margin-left: 10px;"
                    class="btn btn-primary pull-right ">
                    Générer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

  </div>
</template>

<script type="text/babel">
import {mapGetters, mapActions} from 'vuex'

import {quillEditor} from 'vue-quill-editor'

require('../../../node_modules/bootstrap-datepicker/js/bootstrap-datepicker');
require('../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.fr');

export default {
  data() {
    return {
      name: 'base-example',
      editorOption: {},
      objet: null,
      date: new Date().toLocaleDateString(),
      dateDemande: new Date().toLocaleDateString(),
      anneeDemande: new Date().getFullYear(),
      signature: null,
      choixPregenerer: null,
      choixLicence: null,
      choixLicenceClub: null,
      allLicences: null,
      allLicencesClub: null,
      adresseDestinataire: null,
      generatingPDF: false,
      generatingTemplate: false,
      columnsSelected: ['numlicenceABFT','genre', 'nom', 'prenom', 'adresse', 'cp', 'ville', 'date_entree', 'date_naissance', 'tel', 'gsm', 'mail'],
      content: '',
      config: {
        toolbar:
          [
            {
              name: 'document',
              items: ['Source', '-', 'Save', 'NewPage', 'Preview', 'Print', '-', 'Templates']
            },
            {
              name: 'clipboard',
              items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo']
            },
            '/',
            {
              name: 'basicstyles',
              items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat']
            },
            {
              name: 'paragraph',
              items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl']
            },
            {name: 'links', items: ['Link', 'Unlink', 'Anchor']},
            {
              name: 'insert',
              items: ['Image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak']
            },
            '/',
            {name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize']},
            {name: 'colors', items: ['TextColor', 'BGColor']},
            {name: 'tools', items: ['Maximize', 'ShowBlocks']}
          ],
        height: 300,
      }
    }
  },
  methods: {
    ...mapActions({
      majUserSelected: "majUserSelected",
      majClubSelected: "majClubSelected",
      removeUserSelected: "removeUserSelected",
      removeClubSelected: "removeClubSelected",
    }),
    disabledButton: function () {
      if (this.choixPregenerer == "AttestationAffiliationClub")
        return !(this.choixLicenceClub != null)
      return false
    },
    replaceAll: function (str, find, replace) {
      return str.replace(new RegExp(find, 'g'), replace);
    },
    exportToPDF: function () {
      var these = this;
      this.generatingPDF = true

      var request = {
        typeCourrier: these.choixPregenerer,
        data: {
          "adresse_destinataire": these.adresseDestinataire != null ? this.replaceAll(these.adresseDestinataire, '\n', '<br/>') : "",
          "objet": these.objet,
          "content": these.content,
          "columns": these.columnsSelected,
          "date_demande": these.dateDemande,
          "annee_demande": these.anneeDemande,
          "club": these.getClubSelected
        }
      }

      this.$http.post(this.getRoute('routeCourrierPDF'), request, {responseType: "arraybuffer"})
        .then(function (response) {
          let blob = new Blob([response.data], {type: 'application/pdf'})
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = these.choixPregenerer != null ? these.choixPregenerer : 'Courrier.pdf'
          link.click()
          this.generatingPDF = false
        }, (response) => {

        });
    },
    generateTemplate: function () {
      var these = this;
      this.generatingTemplate = true;
      if (this.choixPregenerer == "AttestationAffiliationMembre") {
        var request = {
          id_membre: this.getUserSelected.id,
          id_licence: this.choixLicence,
          typeCourrier: this.choixPregenerer
        }

        this.$http.post(this.getRoute('Secretariat.generateCourrier'), request).then(function (response) {
          let data = response.data
          data = this.prepareResponseData ? this.prepareResponseData(data) : data
          these.objet = data.objet
          these.content = data.content
          these.generatingTemplate = false;

        }, (response) => {
        });
      } else if (this.choixPregenerer == "AttestationAffiliationClub") {
        var request = {
          id_club: this.getClubSelected.id,
          id_licence_club: this.choixLicenceClub,
          typeCourrier: this.choixPregenerer
        }

        this.$http.post(this.getRoute('Secretariat.generateCourrier'), request).then(function (response) {
          let data = response.data
          data = this.prepareResponseData ? this.prepareResponseData(data) : data
          these.objet = data.objet
          these.content = data.content
          these.generatingTemplate = false;
        }, (response) => {

        });
      } else if (this.choixPregenerer == "AttestationAffiliationMembresDuClub") {
        var request = {
          id_club: this.getClubSelected.id,
          dateDemande: this.dateDemande,
          typeCourrier: this.choixPregenerer,
          columns: this.columnsSelected
        }

        this.$http.post(this.getRoute('Secretariat.generateCourrier'), request).then(function (response) {
          let data = response.data
          data = this.prepareResponseData ? this.prepareResponseData(data) : data
          these.objet = data.objet
          these.content = data.content
          these.generatingTemplate = false;
        }, (response) => {

        });
      } else if (this.choixPregenerer == "AttestationAffiliationMembresDuClubActifParAnnee") {
        var request = {
          id_club: this.getClubSelected.id,
          anneeDemande: this.anneeDemande,
          typeCourrier: this.choixPregenerer,
          columns: this.columnsSelected
        }

        this.$http.post(this.getRoute('Secretariat.generateCourrier'), request).then(function (response) {
          let data = response.data
          data = this.prepareResponseData ? this.prepareResponseData(data) : data
          these.objet = data.objet
          these.content = data.content
          these.generatingTemplate = false;
        }, (response) => {

        });
      } else if (this.choixPregenerer == "AttestationAffiliationMembresDuClubPayeDurantAnnee") {
        var request = {
          id_club: this.getClubSelected.id,
          anneeDemande: this.anneeDemande,
          typeCourrier: this.choixPregenerer,
          columns: this.columnsSelected
        }

        this.$http.post(this.getRoute('Secretariat.generateCourrier'), request).then(function (response) {
          let data = response.data
          data = this.prepareResponseData ? this.prepareResponseData(data) : data
          these.objet = data.objet
          these.content = data.content
          these.generatingTemplate = false;
        }, (response) => {

        });
      }
    },
    fill_all_licences: function () {
      if (this.choixPregenerer == "AttestationAffiliationMembre") {
        var these = this;
        var request = {
          type_licence: "no-transfert" //On demande les licences sans les transferts
        }
        this.$http.post(this.getRoute('getLicencesForOneMember') + this.getUserSelected.id, request).then(function (response) {
          let data = response.data
          data = this.prepareResponseData ? this.prepareResponseData(data) : data
          these.allLicences = data
        }, (response) => {
        });
      } else if (this.choixPregenerer == "AttestationAffiliationClub") {
        var these = this;
        this.$http.get(this.getRoute('getLicencesForOneClub') + this.getClubSelected.id).then(function (response) {
          let data = response.data
          data = this.prepareResponseData ? this.prepareResponseData(data) : data
          these.allLicencesClub = data
        }, (response) => {
        });
      }
    }
  },
  computed: {
    ...mapGetters({
      getUserSelected: 'getUserSelected',
      getClubSelected: 'getClubSelected',
      getRoute: 'getRoute'
    }),
    editor() {
      return this.$refs.myTextEditor.quill
    }
  },
  components: {
    quillEditor,
  },
  watch: {
    choixPregenerer: function (value) {
      this.removeUserSelected()
      this.removeClubSelected()
      this.choixLicence = null
      this.choixLicenceClub = null
    },
    getUserSelected: function (value) {
      if (value && value != "") {
        this.fill_all_licences()
        this.adresseDestinataire =
          this.getUserSelected.genre + " " + this.getUserSelected.fullName
          + "\n" + this.getUserSelected.adresse
          + "\n" + this.getUserSelected.cp + " " + this.getUserSelected.ville
      }
    },
    getClubSelected: function (value) {
      if (value && value != "") {
        var membre = {}
        this.fill_all_licences()
        if (this.getClubSelected.comite.correspondant != null && this.getClubSelected.comite.correspondant.length > 0)
          membre = this.getClubSelected.comite.correspondant[0];
        else if (this.getClubSelected.comite.president != null && this.getClubSelected.comite.president.length > 0)
          membre = this.getClubSelected.comite.president[0];
        else
          return this.adresseDestinataire = "";

        this.adresseDestinataire =
          membre.fullName
          + "\n" + membre.adresse
          + "\n" + membre.cp + " " + membre.ville
      }
    },
  },
  mounted() {
    var these = this
    this.$nextTick(function () {
      $('#datepicker1').datepicker({
        autoclose: true,
        language: 'fr'
      }).on("changeDate", function (e) {
        these.date = $('#datepicker1').val()
      });

      $('#datepicker2').datepicker({
        autoclose: true,
        language: 'fr'
      }).on("changeDate", function (e) {
        these.dateDemande = $('#datepicker2').val()
      });
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Outils/GenerationCourrier.vue